/** Default visible columns in left-to-right display order (table schema order can differ). */
export const POLICIES_TABLE_DEFAULT_VISIBLE_KEYS = [
  'rider_id',
  'apartment_building_name',
  'tenant_1_name',
  'stage',
  'app_type',
  'sf_createdDate',
  'coverage_start_date',
  'coverage_end_date',
  'active_lease',
  'actions',
];

export const POLICIES_TABLE_DEFAULT_VISIBLE_KEYS_WITHOUT_BUILDING = [
  'rider_id',
  'tenant_1_name',
  'stage',
  'app_type',
  'sf_createdDate',
  'coverage_start_date',
  'coverage_end_date',
  'active_lease',
  'actions',
];

/** Bump when default columns/order change so persisted prefs reset. */
export const POLICIES_TABLE_STORAGE_KEY = 'policies-list-v5';
